import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (path) => `${API}/files/${path}`;

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/upload-image`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { path, size, content_type }
};

export const createEntry = async (payload) => {
  const { data } = await axios.post(`${API}/entries`, payload);
  return data;
};

// ---------- Admin ----------
const ADMIN_KEY = "stayside_admin_pw";

export const getAdminPassword = () => localStorage.getItem(ADMIN_KEY) || "";
export const setAdminPassword = (pw) => localStorage.setItem(ADMIN_KEY, pw);
export const clearAdminPassword = () => localStorage.removeItem(ADMIN_KEY);

const adminHeaders = () => ({ "X-Admin-Password": getAdminPassword() });

export const adminVerify = async (pw) => {
  await axios.post(`${API}/admin/verify`, null, {
    headers: { "X-Admin-Password": pw },
  });
};

export const adminListEntries = async () => {
  const { data } = await axios.get(`${API}/admin/entries`, {
    headers: adminHeaders(),
  });
  return data;
};

export const adminToggleHide = async (id) => {
  const { data } = await axios.patch(
    `${API}/admin/entries/${id}/hide`,
    null,
    { headers: adminHeaders() },
  );
  return data;
};

export const adminDeleteEntry = async (id) => {
  const { data } = await axios.delete(`${API}/admin/entries/${id}`, {
    headers: adminHeaders(),
  });
  return data;
};

export const uploadEntryPicture = async (entryId, imageBlob) => {
  const form = new FormData();
  form.append("file", imageBlob, `${entryId}.jpg`);
  const { data } = await axios.post(
    `${API}/entries/${entryId}/picture`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return data;
};

export const listEntries = async (nestId) => {
  const { data } = await axios.get(`${API}/entries`, {
    params: nestId ? { nest_id: nestId } : undefined,
  });
  return data;
};

export const getEntry = async (id) => {
  const { data } = await axios.get(`${API}/entries/${id}`);
  return data;
};

// ---------- Check-in ----------
export const checkinLookup = async (slug) => {
  const { data } = await axios.get(`${API}/checkin/${slug}`);
  return data;
};

export const adminListCheckinTemplates = async () => {
  const { data } = await axios.get(`${API}/admin/checkin/templates`, {
    headers: adminHeaders(),
  });
  return data;
};

export const adminUpdateCheckinTemplate = async (nestId, patch) => {
  const { data } = await axios.put(
    `${API}/admin/checkin/templates/${nestId}`,
    patch,
    { headers: adminHeaders() },
  );
  return data;
};

export const adminListReservations = async () => {
  const { data } = await axios.get(`${API}/admin/reservations`, {
    headers: adminHeaders(),
  });
  return data;
};

export const adminCreateReservation = async (payload) => {
  const { data } = await axios.post(`${API}/admin/reservations`, payload, {
    headers: adminHeaders(),
  });
  return data;
};

export const adminDeleteReservation = async (id) => {
  const { data } = await axios.delete(`${API}/admin/reservations/${id}`, {
    headers: adminHeaders(),
  });
  return data;
};

export const adminGetAnalytics = async () => {
  const { data } = await axios.get(`${API}/admin/analytics`, {
    headers: adminHeaders(),
  });
  return data;
};
